module.exports = __webpack_public_path__ + "static/media/webDev.a732a9e9.jpg";